import AsyncComputed from 'vue-async-computed'
import Vue           from 'vue'

Vue.use AsyncComputed
